import styled from 'styled-components';
import colors from '../../styles/colors';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 30px 0 80px 0;

    /* Tutte le immagini partono dall alto e non dal centro*/
    & img {
        object-position: top;
    }
`;

const LineDivider = styled.div`
    width: 90%;
    height: 1px;
    background-color: ${colors.bgColorBlack2};
    margin: 20px 0;

    &.no-margin {
        margin: 2px;
    }
`;

const BoxAllOpponents = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    background: linear-gradient(160deg, rgba(163, 27, 27, 0.12) 0%, rgba(0, 0, 0, 0.25) 100%);
    color: white;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(163, 27, 27, 0.35);
    padding-top: 30px;
`;

const BoxSingleOpponent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* border: 3px solid ${colors.bgColorBlack2}; */
    margin: 10px 0;
    padding: 10px;
`;

const BoxLeftAvatarNameOpponent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 15%;
    
    & img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        cursor: pointer;
    }

    & h6 {
        margin: 0;
    }

    & img:hover {
        color: ${colors.bgColorBordeaux};
        font-weight: bold;
        transform: scale(1.1);
    }
`;

const BoxRightStatsOpponent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    flex-wrap: wrap;
    width: 75%;
`;

const RowSingleFight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    width: 25%;
    margin: 2px 0;
    cursor: pointer;

    & img.ppv-avatar-opponent {
        width: 25px;
        height: 25px;
        object-fit: cover;
    }

    & h6 {
        font-weight: 500;
        margin: 0;
    }

    &:hover {
        color: ${colors.bgColorBordeaux};
        font-weight: bold;
    }
`;

const TopDecorColor = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: ${colors.bgColorBlack2};
`;

function WrestlerBestOpponents({ wrestlerData }: any) {
    const navigate = useNavigate();

    const navigateToPpv = (ppv: any) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }

    const navigateToWrestler = (wrestler: any) => {
        const wrestlerId = wrestler.id;
        const wrestlerName = wrestler.name;
        navigate(`/wrestlers/i_${wrestlerId}_d_${wrestlerName}`);
    }

    return (
        <Container>
            {/* Linea che divide i componenti */}
            {/* <LineDivider /> */}

            {/* Titolo */}
            <h1>Nemici/Amici</h1>
            <p>I lottatori con cui ha avuto maggiori interazioni</p>

            <BoxAllOpponents>
                <TopDecorColor className="top-decor-color" />

                {/* Ciclo wrestlerData.mostChallenged */}
                {wrestlerData.mostChallenged.map((opponent: any, key: any) => (
                    <BoxSingleOpponent className="box-single-opponent" key={key}>

                        <BoxLeftAvatarNameOpponent>
                            <img 
                                src={process.env.REACT_APP_STORAGE_URL + opponent.avatar_path} 
                                alt={opponent.name} 
                                onClick={() => {
                                    console.log('Image clicked for wrestler:', opponent.name);
                                    navigateToWrestler(opponent);
                                }} 
                            />
                            <h6>{opponent.name}</h6>
                        </BoxLeftAvatarNameOpponent>

                        <BoxRightStatsOpponent>
                            {/* ciclo fights dentro opponent */}
                            {opponent.fights.map((fight: any, key: any) => (
                                <RowSingleFight className="row-single-fight" key={key}>
                                    <div className="box-ppv d-flex justify-content-center align-items-center" onClick={() => navigateToPpv(fight.ppv)}>
                                        <img className="ppv-avatar-opponent" src={process.env.REACT_APP_STORAGE_URL + fight.ppv.ppv_description.img_path} alt={fight.ppv.ppv_description.name} />
                                        <h6 className="ppv-name-opponent mx-1"> {fight.ppv.ppv_description.name} - {fight.type_match.name}</h6>
                                    </div>
                                </RowSingleFight>
                            ))}
                        </BoxRightStatsOpponent>
                    </BoxSingleOpponent>
                ))}
            </BoxAllOpponents>
        </Container>
    )
}

export default WrestlerBestOpponents;